// src/components/FindIdPwNavigation.tsx

import React from 'react';
import { NavLink } from 'react-router-dom';

const FindIdPwNavigation: React.FC = () => {
  return (
    <div className="flex border-b mb-4 ">
      <NavLink
        to="/find/id"
        className={({ isActive }) =>
          `flex-1 py-2 text-center ${
            isActive
              ? 'border-b-2 border-[#04c2c5] text-[#04c2c5]'
              : 'text-gray-500'
          }`
        }
      >
        아이디 찾기
      </NavLink>
      <NavLink
        to="/find/pw"
        className={({ isActive }) =>
          `flex-1 py-2 text-center ${
            isActive
              ? 'border-b-2 border-[#04c2c5] text-[#04c2c5]'
              : 'text-gray-500'
          }`
        }
      >
        비밀번호 찾기
      </NavLink>
    </div>
  );
};

export default FindIdPwNavigation;
